import _ from "lodash";

function messageSeenEvent(data) {
  const { bookingDetails = {}, messageIds = [] } = data;

  const chatBookingId = bookingDetails.id;

  if (!chatBookingId) {
    return;
  }

  // 1 scenerio
  // In the  dashboard messages page and selected the chat - update the chat messages of the opponent

  const currentLocation = window.location.pathname;
  const isDashboardMessagesPage = currentLocation.includes(
    "/dashboard/messages"
  );

  if (isDashboardMessagesPage) {
    const bookingId =
      Number(new URLSearchParams(window.location.search).get("bookingId")) ||
      null;

    if (bookingId === chatBookingId) {
      const unseenMessages = document.querySelectorAll(
        "#chat-body .chat-msg.chat-guest-msg[data-is-seen='false']"
      );

      if (unseenMessages.length === 0) {
        return;
      }

      // unseenMessages.forEach((messageElement) => {
      //   const messageId = Number(
      //     messageElement.getAttribute("data-message-id")
      //   );

      //   if (!_.isEmpty(messageIds) && !messageIds.includes(messageId)) {
      //     return;
      //   }

      //   messageElement.setAttribute("data-is-seen", "true");
      // });

      unseenMessages.forEach((messageElement) => {
        const maxAttempts = 5;
        let attempt = 1;

        const checkAndUpdate = () => {
          const rawMessageId = messageElement.getAttribute("data-message-id");
          const messageId = Number(rawMessageId);

          // If the conversion gives a valid number, we update and stop polling.
          if (!Number.isNaN(messageId)) {
            // If messageIds array exists and doesn't include this id, skip updating.
            if (!_.isEmpty(messageIds) && !messageIds.includes(messageId)) {
              return;
            }
            messageElement.setAttribute("data-is-seen", "true");
            return;
          }

          // If not a valid number and we haven't reached maxAttempts, try again.
          if (attempt < maxAttempts) {
            attempt++;
            setTimeout(checkAndUpdate, 1000);
          }
        };

        // Start the polling process.
        checkAndUpdate();
      });
    }
  }
}

export default messageSeenEvent;
